<script setup>
import { onMounted, computed, defineProps } from 'vue';
import { useStore } from 'vuex'
import _ from 'lodash'

const props = defineProps({
  editable: {
    type: Boolean,
    default: true
  }
});

onMounted(()=>{
  getViolationList();
  getViolation();
});

const store = useStore()

const violation_list = computed(() => store.state.trafficRecordComponent.violation_list);
const selected_violation = computed({
  get:() => store.state.trafficRecordComponent.selected_violation,
  set:(val) => store.commit('trafficRecordComponent/SET_SELECTED_VIOLATION',val)
});

const camera_capture_violation = computed({
  get:() => store.state.trafficRecordComponent.camera_capture_violation,
  set:(val) => store.commit('trafficRecordComponent/SET_CAMERA_CAPTURE_VIOLATION',val)
});

const getViolationList = () => store.dispatch('trafficRecordComponent/getViolationList');
const getViolation = () => store.dispatch('trafficRecordComponent/getViolation');

const loading = computed(() => store.state.globals.loading);

const penaltyFee = computed(() => {
  const fee = _.find(violation_list.value, (v) => { 
    return v.id == selected_violation.value; 
  });
  if(!fee){
    return 0;
  }
  return fee.penalty_fee;
})

</script>

<template>
  <b-overlay :show="loading">
    <div class="card">
      <div class="card-body overflow-auto">
        <table class="table table-bordered table-sm table-light m-0">
          <tbody>
            <tr>
              <th colspan="2" class="text-center">Base Violations</th>
            </tr>
            <tr>
              <td colspan="2" class="text-center">
                Camera Captured Violation: <span class="text-success">{{camera_capture_violation}}</span>
              </td>
            </tr>
            <tr>
              <td class="text-center">
                <select v-if="props.editable" required class="form-select" v-model="selected_violation">
                  <template v-for="option in violation_list" :key="option.id" >
                    <option :value="option.id">
                      {{ option.violation.name }}
                    </option>
                    <option class="article" disabled>
                      {{ option.violation.article }}
                    </option>
                  </template>
                </select>
                <select v-if="!props.editable" disabled class="form-select" :value="selected_violation">
                  <template v-for="option in violation_list" :key="option.id" >
                    <option :value="option.id">
                      {{ option.violation.name }}
                    </option>
                    <option class="article" disabled>
                      {{ option.violation.article }}
                    </option>
                  </template>
                </select>
              </td>
              <td class="no-wrap text-center align-middle">PHP {{ penaltyFee }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </b-overlay>
</template>

<style scoped>
select option{
  font-size:14px;  
}
select option.article{
  font-size:10px;  
}
.no-wrap{
  min-width: fit-content;
  width: 100px;
  white-space: nowrap;
}
td{
  padding:5px;
}
</style>
